module.exports = __webpack_public_path__ + "img/john.b80858ce.jpeg";